import { useEffect, useState } from "react";
import { Button } from "Components/Button";
import { CartSearch } from "Components/ServiceForm/CartSearch";
import { useBudgetContext } from "Hooks/useBudgetContext";
import { BudgetDocuments } from "Dtos/IBudget";
import { Documents } from "./Document";
import { ModalReplaceProducts } from "../ModalReplaceProducts";

export const Tabs = () => {
  const [tab, setTab] = useState<"products" | "files">("products");

  const {
    budget,
    documents,
    replaceProductModal,
    setReplaceProductModal,
    isCreatingIABudget,
  } = useBudgetContext();

  function convertDocumentsInfo(files: BudgetDocuments[]) {
    if (!files) return [];

    const documentsList = documents?.map((document) => {
      const docFormat = document.file_path.slice(-3);

      return {
        id: document.file_path.slice(-10),
        file_path: document.file_path,
        filename: document.name,
        preview: `data:image/${docFormat};base64, ${document.base64}`,
        isImage: !document.file_path.endsWith(".pdf"),
      };
    });
    return documentsList;
  }

  const files = convertDocumentsInfo(documents);

  useEffect(() => {
    if (!budget) setTab("products");
  }, [budget]);

  return (
    <div>
      {isCreatingIABudget && files.length >= 1 && (
        <div className="tabs">
          <Button
            onClick={() => setTab("products")}
            outlined={tab !== "products"}
          >
            Buscar produtos
          </Button>
          {files.length >= 1 && (
            <Button onClick={() => setTab("files")} outlined={tab !== "files"}>
              Visualizar Pedidos Médicos
            </Button>
          )}
        </div>
      )}

      {tab === "products" && <CartSearch />}

      {tab === "files" && files.length >= 1 && (
        <div className="documents">
          <Documents files={files} />
        </div>
      )}

      {budget?.cart.length && replaceProductModal && (
        <ModalReplaceProducts
          isOpen={replaceProductModal}
          onClose={() => setReplaceProductModal(false)}
          itemsInCart={budget?.cart}
        />
      )}
    </div>
  );
};
